var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuVitrine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.491,
    height: 31.842,
    viewBox: "0 0 28.491 31.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-vitrine",
    transform: "translate(-7.097 -4.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1455",
    "data-name": "Caminho 1455",
    d: "M11.673,36.011h19.34a4.6,4.6,0,0,0,4.57-4.812l-.932-18.1a1.141,1.141,0,0,0-.091-.277L33.032,10.41a1.764,1.764,0,0,0-1.657-.8l.1-.48A1.711,1.711,0,0,0,30.221,7.11l-5.6-1.422a1.719,1.719,0,0,0-2.083,1.231l-.366,1.409-.631.158-.185-2.22a2.3,2.3,0,0,0-2.542-2.083l-6.2.714a2.3,2.3,0,0,0-2.007,2.571l.284,2.167a1.2,1.2,0,0,0-1.162.559L8.158,12.837a1.289,1.289,0,0,0-.077.261L7.1,31.188a4.6,4.6,0,0,0,4.57,4.823Zm19.46-25.255h.449a.57.57,0,0,1,.483.266l.972,1.536H30.75ZM23.647,7.207a.573.573,0,0,1,.695-.411l5.6,1.422a.57.57,0,0,1,.418.674l-.778,3.665H26.139l-.8-3.247a1.7,1.7,0,0,0-1.909-1.281Zm-.111,1.957a.575.575,0,0,1,.695.419l.73,2.974H16.4c-.1-.541-.606-1.4.162-1.64Zm-11.557-2.7a1.139,1.139,0,0,1,.767-.435l6.2-.714a1.161,1.161,0,0,1,1.271,1.041l.2,2.407L16.279,9.808c-1.281.327-1.522,1.653-1.067,2.75H12.429l-.686-5.239a1.141,1.141,0,0,1,.236-.85Zm-1.265,4.31h.328l.233,1.779H9.655ZM8.245,31.25,9.194,13.7s24.339,0,24.342,0l.9,17.556a3.432,3.432,0,0,1-3.428,3.609H11.673A3.448,3.448,0,0,1,8.245,31.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1456",
    "data-name": "Caminho 1456",
    d: "M22.111,27.975v2.637a5.085,5.085,0,0,0,10.169,0V27.975a1.9,1.9,0,1,0-1.144,0v2.637a3.941,3.941,0,0,1-7.881,0V27.975a1.908,1.908,0,1,0-1.144,0Zm9.6-2.575a.764.764,0,1,1-.764.764.764.764,0,0,1,.764-.764Zm-9.025,0a.764.764,0,1,1-.764.764.764.764,0,0,1,.764-.764Z",
    transform: "translate(-5.854 -8.592)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVitrine);
export default __webpack_public_path__ + "static/media/menu-vitrine.208763962079282ab09c70f11ef44e8b.svg";
export { ForwardRef as ReactComponent };